import React from 'react';
import sam4 from './sam4.jpeg'
import sam3 from './sam3.jpeg'

function Header(){
    const navToggle = document.querySelector('.nav-toggle');
    
 

    return(
        <>
        <body>
        <header>
            <div className="logo">
                <img src="img/devjane.png" alt=""/>
            </div>
            
            <nav className="nav">
                <ul className="nav__list">
                    <li className="nav__item"><a href="#home" className="nav__link">Home </a></li>
                    <li className="nav__item"><a href="#services" className="nav__link">My Services </a></li>
                    <li className="nav__item"><a href="#about" className="nav__link">About me</a></li>
                    <li className="nav__item"><a href="#work" className="nav__link">My Work</a></li>
                </ul>
            </nav>
        </header>
        <section class="intro" id="home">
            <h1 className="section__title section__title--intro">
                Hi, I am <strong>Samarth Gowda</strong>
            </h1>
            <p className="section__subtitle section__subtitle--intro">Full Stack Web-dev</p>
            <img src={sam3} alt="a picture of Jane Smith smiling" className="intro__img"/>
        </section>
        
        
    
        <section className="my-services" id="services">
            <h2 className="section__title section__title--services">What I do</h2>
            <div className="services">
                <div className="service">
                    <h3>Web Development</h3>
                    <p>I love to develop beautiful websites projects in my grace time to increase my finger tips on it</p>
                </div> 
                
                <div className="service">
                    <h3>Backend Development</h3>
                    <p>I like to develop Backend projects using technologies such as NodeJS, Express and MySQL</p>
                </div> 
                
                <div className="service">
                    <h3>Python Programming</h3>
                    <p>I use Python as my primary language to code and to solve coding problems</p>
                </div> 
            </div> 
            
            
        </section>
        
        
    
        <section className="about-me" id="about">
           <h2 className="section__title section__title--about">Who I am</h2>
           <img src={sam4} alt="Jane leaning against a bus"/>
           <p className="section__subtitle section__subtitle--about"> UI/UX Designer &&  Software Developer based out of NYC</p>
           
           
           <div className="about-me__body">
           
               <p>I'm a Graduate student currently in my final semester majoring in Computer Science at Pace University, One Pace Plaza, NYC. </p>
               <p>I'm Currently Interning as a Software Engineer at Shoptaki</p>
               <p>Ability to learn and adopt relevant new technologies, tools, methods, and processes to leverage for solving a problem. Passionate about building software solutions that make the world a better place.</p>
           </div>
           
           
           
        </section>
        
        
        <section className="my-work" id="work">
            <h2 className="section__title">My work</h2>
            <p className="section__subtitle"></p>
            
            <div className="portfolio">
                
                <a href="https://github.com/samarthgowda96/Unitfit" className="portfolio__item">
                    <h3>UnitFit</h3> 
                    <p>Developing a Full Stack application using ReactJS framework and MySQL database in order to provide users with the workout videos, nutritional tips, and  daily meals. </p>
                </a>
                
                
                <a href="https://github.com/samarthgowda96/predictingthunderstorms" className="portfolio__item">
                    <img src="img/portfolio-02.jpg" alt="" className="portfolio__img"/>
                    <h3>Predicting ThunderStorms</h3>
                    <p>Coded a application using Neural Network Algorithm to predict a thunderstorm for a particular week based on the previous 14 weeks dataset.</p>
                </a>
                <a href="https://github.com/samarthgowda96/MovieSearch" className="portfolio__item">
                    <img src="img/portfolio-09.jpg" alt="" className="portfolio__img"/>
                    <h3>MovieSearch</h3>
                    <p> Created and developed a MovieSearch database application using ReactJS Framework to display movies based on the search</p>
                </a>
                
                
                <a href="https://github.com/samarthgowda96/covid-19" className="portfolio__item">
                    <img src="img/portfolio-03.jpg" alt="" className="portfolio__img"/>
                    <h3>COVID-19</h3>
                    <p>	Independently developed and deployed an Hybrid Web Application using Angularjs, integrated a third-party REST API to display the Covid-19 information.</p>
                </a>
                
                
                <a href="https://github.com/samarthgowda96/React" className="portfolio__item">
                    <img src="img/portfolio-04.jpg" alt="" className="portfolio__img"/>
                    <h3>Gowda's Blog</h3>
                    <p>	Developed a basic web based application using ReactJS framework to display various models of Kawasaki models, Implemented a live weather forecast API on every page to display the current weather condition. </p>
                </a>
                
                
                <a href="https://github.com/samarthgowda96/tictac" className="portfolio__item">
                    <img src="img/portfolio-05.jpg" alt="" className="portfolio__img"/>
                    <h3>TicTacToc Game</h3>
                    <p>Designed and developed a basic TicTacToc game using newly introduced features of ReactJS framework</p>
                </a>
                <a href="#" className="portfolio__item">
                    <img src="img/portfolio-09.jpg" alt="" className="portfolio__img"/>
                    <h3></h3>
                    <p></p>
                </a>
            
               
                <a href="https://github.com/samarthgowda96/DBMS" className="portfolio__item">
                    <img src="img/portfolio-07.jpg" alt="" className="portfolio__img"/>
                    <h3>PaperReview Java</h3>
                    <p>Designed and developed a SQL database for  Research Paper review ER model using and have written SQL queries to conduct different operation on the data.</p>
                </a>
                <a href="#" className="portfolio__item">
                    <img src="img/portfolio-09.jpg" alt="" className="portfolio__img"/>
                    <h3></h3>
                    <p></p>
                </a>
                
                <a href="https://github.com/samarthgowda96/Data-Mining" className="portfolio__item">
                    <img src="img/portfolio-08.jpg" alt="" className="portfolio__img"/>
                    <h3>Story Telling Using COVID-19</h3>
                    <p>Conducted an Exploratory Data Analysis (EDA) using R on a COVID-19 dataset (provided by Kaggle Warehouse) to determine the correlation and causes that are responsible for the novel Coronavirus outbreak.</p>
                </a>
                
               
            </div>
        </section>
        
        
        
        <footer className="footer">
           
            <a href="samarthgowda13@gmail.com" className="footer__link">Contact Me :Samarth Venkatesh Gowda</a>
            <ul class="social-list">
                <li class="social-list__item">
                    <a class="social-list__link" href="https://www.linkedin.com/in/samarth-gowda96">
                        <i class="fab fa-linkedin"></i>

                    </a>
                </li>
                <li class="social-list__item">
                    <a class="social-list__link" href="https://github.com/samarthgowda96">
                         <i class="fab fa-github"></i>
                    </a>
                </li>
                <li class="social-list__item">
                    <a class="social-list__link" href="https://www.hackerrank.com/SamarthVGowda">
                    <i class="fab fa-hackerrank"></i>
                    </a>
                </li>
                <li class="social-list__item">
                    <a class="social-list__link" href="https://app.codesignal.com/profile/samarthgowda96">
                    <i class="fab fa-codepen"></i>
                    </a>
                </li>
            </ul>
        </footer>
        </body>
        
        </>
    )
}

export default Header;

